const WinlosesTypes = {
    FETCH_START:    '[BAR] FETCH START',
    FETCH_SUCCESS:  '[BAR] FETCH SUCCESS',
    FETCH_FAILURE:  '[BAR] FETCH FAILURE'
};

export default WinlosesTypes;